<template>
  <div class="wrld-box mb-4">
    <v-toolbar color="secondary" class="py-1 box-header">
      <v-toolbar-title>{{ headerTitle }}</v-toolbar-title>
      <ais-instant-search
        v-if="search.showSearch"
        :search-client="searchClient"
        index-name="prod_orders"
      >
        <ais-search-box>
          <v-text-field
            prepend-inner-icon="search"
            :label="$t('search')"
            class="box-search-box"
            solo
            v-model="search.query"
          ></v-text-field>
        </ais-search-box>
      </ais-instant-search>

      <v-spacer></v-spacer>
      <slot name="headerBtns"></slot>
      <v-btn
        v-if="hideableContent"
        text icon
        color="kazan"
        @click="boxContentHidden = !boxContentHidden"
      >
        <v-icon v-if="!boxContentHidden" medium>remove_circle_outline</v-icon>
        <v-icon v-else medium>add_circle_outline</v-icon>
      </v-btn>

    </v-toolbar>
    <v-card v-show="!boxContentHidden" class="box-content elevation-4" >
      <slot name="boxContent"></slot>
    </v-card>
  </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'

export default {
  name: 'wrld-box',
  props: {
    headerTitle: String,
    search: {
      type: Object,
      default: () => {
        return {
          showSearch: false,
          query: ''
        }
      }
    },
    hideableContent: {
      type: Boolean,
      default: false
    },
    hiddenContent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchClient: algoliasearch(
        '9N5LGLZPRT',
        'e5b8a01d8c6ca064424f71e630360d15'
      ),
      boxContentHidden: this.hiddenContent
    }
  }
}
</script>

<style scoped lang="scss">
   .v-card {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
   }
 </style>
